export default {
  receiverSettings: (state) => state.receiverSettings
}
